import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'
import { getRequest, postRequest, patchRequest, deleteRequest } from '@/plugins/api-axios'

@Mixin
export default class LogMixin extends Vue {
    logURL = process.env.VUE_APP_LOG_BASE_URL

    get headersmixins() {
        return {
            'Content-Type': 'application/vnd.api+json',
        }
    }

    // EVENT
    async getEvents(params: any) {
        let url = `${this.logURL}/events?include=actingUser`
        let res = await getRequest(url, this.headersmixins, params)

        // let comments: any = {}
        let users: any = {}
        // let reactions: any = {}
        // let attachments: any = {}

        // res.data.data.map((item: any) => {
        //     comments[item.id] = item
        // })

        res.data.included.map((item: any) => {
            switch (item.type) {
                case 'user':
                    users[item.id] = item
                    break
                // case "reaction":
                //     reactions[item.id] = item
                //     break;
                // case "attachment":
                //     attachments[item.id] = item
                //     break;
            }
        })

        // this.$store.commit('comments', { ...this.$store.getters.comments, ...comments})
        // this.$store.commit('commentUsers', { ...this.$store.getters.commentUsers, ...users})
        // this.$store.commit('reactions', { ...this.$store.getters.reactions, ...reactions})
        // this.$store.commit('commentAttachments', { ...this.$store.getters.commentAttachments, ...attachments})
        this.$store.commit('notificationUsers', {
            ...this.$store.getters.notificationUsers,
            ...users,
        })

        return res.data.data
    }
}
